namespace $.$$ {
	export class $shm_hitalama_map_widget_float_ai_request_html_changes extends $.$shm_hitalama_map_widget_float_ai_request_html_changes {

		prompt(): string {
			const text = this.$.$mol_fetch.text( $shm_hitalama_ghpages_fix_link( '/shm/hitalama/map/snippets/_prompt_html_changes_short.md' ) )
			return text.replace( '{{Описание изменений}}', this.text() )
		}

	}
}
